import Gallery from "./Gallery";
import GalleryNav from "./GalleryNav";

function Designs() {
    return (
        <article>
            <div className="large-card">
                <h3>Designs</h3>
                <GalleryNav />
                <div className="separator"></div>
                <Gallery />
            </div>
        </article>
    )
}

export default Designs;